export type HeaderProps = {
  rightSideText?: string;
};

export const Header = ({ rightSideText }: HeaderProps) => {
  return (
    <header className="flex justify-between items-center px-8 h-[15vh]">
      <p className="heading3 text-nowrap text-default">Arsenik Records</p>
      {rightSideText && (
        <>
          <div className="border w-full border-default mx-8" />
          <p className="heading3 text-nowrap text-default">{rightSideText}</p>
        </>
      )}
    </header>
  );
};
